import React from "react";
import Text from "@atlas/uicorn/lib/Display/Text";
import styled from "styled-components";
import { AppSettings } from "../../lib/get-app-settings";

export default function StandardLayoutHeader(
  props: TStandardLayoutHeaderProps
) {
  const { appSettings } = props;

  return (
    <SHeader>
      <Text h="1">{appSettings.supportPortalTitle}</Text>
      <Text>{appSettings.supportPortalDescription}</Text>
    </SHeader>
  );
}

const SHeader = styled.div`
  margin: 58px 0 3px;
`;

type TStandardLayoutHeaderProps = {
  appSettings: AppSettings;
};
